export default "__VITE_ASSET__BwybgzLw__"